import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faArrowRight from '@fortawesome/fontawesome-free-solid/faArrowRight'
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner'

import './group_login_page_container.scss'
import { parentRedirect } from '../utils/utils'
import InputWithIcon from '../components/input_with_icon'
import NoticeBox from '../components/notice_box'

export default class GroupLoginPageContainer extends React.Component
  constructor: (props) ->
    super(props)
    @state = { notice: null }

  submitForm: (e) =>
    e.preventDefault()
    @setState notice: null, submitting: true
    $.post(@props.submitURL, $(@refs.form).serialize())
      .then (data) =>
        if data.error
          @setState notice: data.error, submitting: false
        else if data.success
          parentRedirect(@props.successURL)

  renderNoticeBox: ->
    notice = @props.notice || @state.notice
    return null unless notice
    <NoticeBox type="error" content={{ message: notice }}/>

  render: ->
    if @state.submitting
      disabled = true
      label = <FontAwesomeIcon icon={faSpinner} spin/>
    else
      disabled = false
      label = <FontAwesomeIcon icon={faArrowRight}/>

    <div className="group-login-page">
      {@renderNoticeBox()}

      <form role="form" ref="form" onSubmit={@submitForm}>
        <input type="text" name="code" placeholder={@props.content.groupLabel}/>
        <Button className="ma-button btn-hudson" variant="contained"
                disabled={disabled} onClick={@submitForm} >
          {label}
        </Button>
      </form>

    </div>

GroupLoginPageContainer.propTypes = {
  content: PropTypes.shape({
    groupLabel: PropTypes.string,
  }),
  notice: PropTypes.object,
  submitURL: PropTypes.string,
  successURL: PropTypes.string
}
